import script from "./ScopeBoundaryLimits.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScopeBoundaryLimits.vue?vue&type=script&setup=true&lang=ts"

import "./ScopeBoundaryLimits.vue?vue&type=style&index=0&id=45abe2ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45abe2ce"]])

export default __exports__